import { render, staticRenderFns } from "./Mailchimp.vue?vue&type=template&id=71942413&"
import script from "./Mailchimp.vue?vue&type=script&lang=js&"
export * from "./Mailchimp.vue?vue&type=script&lang=js&"
import style0 from "./Mailchimp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports